/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { CoverageCalculatorMessage } from "../../../messages";
import {
  FormatMoney,
  getAllInfoByISO,
} from "@vlinder-web/pricing-powerpuff-module-react";
import fhpCalcConfig from "../../../config/fhpCalculator.config.json";

export const triggerTotalCoverage = (lifeCycle: any) => {
  const message = lifeCycle?.fsm?.message as CoverageCalculatorMessage;
  console.log("22ff", message)
  // @ts-ignore
  const countryFound = fhpCalcConfig[message.country];
  if (!countryFound) {
    throw Error(`unsupported country ${message.country} for this product`);
  }
  const format = new FormatMoney({ decimals: 2 });
  const result: any = {
    country: message.country,
    premium: {
      raw: message.premium,
      formatted: format.from(message.premium, {
        symbol: getAllInfoByISO(message.country)?.symbol,
      }),
    },
    policyOptions: [...(countryFound.policyOptions || [])],
  };
  console.log("sdsds2", [...(countryFound.policyOptions || [])],)
  console.log("sdsds3", result.policyOptions)
  if (result) {
    result?.policyOptions?.forEach((opt: any, opti: number) => {
      const rol = opt.rolPct;

      let basePremium = message.premium;

      console.log("Basepremium", basePremium)

      const coverage = basePremium / (rol / 100);

      const cleanCoverage = Number(coverage.toFixed(2));

      let eligibleCoverages = false;

      const config = fhpCalcConfig[message.country as keyof typeof fhpCalcConfig];
      
      eligibleCoverages = cleanCoverage >= config.sliderBounds.coverage.lowerBound && cleanCoverage <= config.sliderBounds.coverage.upperBound;
      
      opt.eligible = eligibleCoverages;
      opt.coverage = {
        raw: coverage,
        formatted: format.from(coverage, {
          symbol: getAllInfoByISO(message.country)?.symbol,
        }),
      };

      opt.conversionType = "coverageConversion";
      let _discount = basePremium * message?.discount;
      let _discountedPremium = basePremium - _discount;

      if (message?.discount) {
        opt.discount = {
          raw: _discountedPremium,
          formatted: format.from(_discountedPremium, {
            symbol: getAllInfoByISO(message.country)?.symbol,
          }),
        };
      }

      opt?.triggeringParams?.forEach((tp: any, tpi: number) => {
        const tpCoverage = coverage * (tp.coveragePct / 100);
        tp.coverage = {
          raw: tpCoverage,
          formatted: format.from(tpCoverage, {
            symbol: getAllInfoByISO(message.country)?.symbol,
          }),
        };
      });
    });
  }

  message.totalCoverage = result;
  console.log("23d", message.totalCoverage)
  return true;
};
